module.exports = __webpack_public_path__ + "img/f23.9553df8e.png";